import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../../environments/environment';
import {
  FilterProps,
  PagedResponse,
} from '../../core/store/general/models/general';
import { IInvitation } from '../../core/store/team/models/invitations';
import {
  ETeamPermission,
  ITeamMember,
  ITeamSeats,
} from '../../core/store/team/models/team';
import { createParams } from '../../core/store/utils/utils';

@Injectable({
  providedIn: 'root',
})
export class TeamService {
  private baseApiUrl: string = environment.API_BASE_URL;

  constructor(private readonly http: HttpClient) {}

  getAllTeamMembers(
    props: FilterProps,
  ): Observable<PagedResponse<ITeamMember>> {
    return this.http.get<PagedResponse<ITeamMember>>(
      `${this.baseApiUrl}/team${createParams(props)}`,
    );
  }

  getSeats(): Observable<ITeamSeats> {
    return this.http.get<ITeamSeats>(`${this.baseApiUrl}/team/seats`);
  }

  removeTeamMember(userId: string): Observable<boolean> {
    return this.http.post<boolean>(`${this.baseApiUrl}/team/remove`, {
      userId,
    });
  }

  editTeamMemberRole(
    userId: string,
    newRole: ETeamPermission,
  ): Observable<boolean> {
    return this.http.put<boolean>(`${this.baseApiUrl}/team/edit-user-role`, {
      userId,
      newRole,
    });
  }

  inviteTeamMember(email: string, role: ETeamPermission): Observable<boolean> {
    return this.http.post<boolean>(`${this.baseApiUrl}/team/invite-user`, {
      email,
      role,
    });
  }

  getInvitations(props: FilterProps): Observable<PagedResponse<IInvitation>> {
    return this.http.get<PagedResponse<IInvitation>>(
      `${this.baseApiUrl}/team/invitations${createParams(props)}`,
    );
  }

  resendInvitation(invitationId: string): Observable<boolean> {
    return this.http.post<boolean>(
      `${this.baseApiUrl}/team/resend-invitation`,
      {
        invitationId,
      },
    );
  }

  removeInvitation(invitationId: string): Observable<boolean> {
    return this.http.post<boolean>(
      `${this.baseApiUrl}/team/remove-invitation`,
      {
        invitationId,
      },
    );
  }
}
